import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  brands,
  categories,
  persons,
  mediagroups,
  providers
} from "data/actions";

import {
  Page,
  PageSection,
  PageBlock,
  PageHeader,
  PageHeaderImage,
  RightDrawer
} from "components/Page";
import BrandHeader from "components/Brand/BrandHeader";
import GenderInfo from "components/Formaters/GenderInfo";
import AgeInfo from "components/Formaters/AgeInfo";
import ChartTargetGender from "components/Charts/ChartTargetGender";
import SegmentList from "components/Lists/SegmentList";
import AvatarList from "components/Lists/AvatarList";
import CategoryGrid from "pages/channels/CategoryGrid";
import BrandCategoryStats from "components/Brand/BrandCategoryStats";
import Paragraphs from "components/Formaters/Paragraphs";
import ReadMore from "components/Formaters/ReadMore";
import Number from "components/Formaters/Number";

import * as os from "osutil";

class BrandPage extends Component {
  state = { tab: "summary" };
  static contextTypes = {
    router: PropTypes.object
  };

  tabs = [
    { label: "Översikt", key: "summary" },
    { label: "Statistik", key: "statistics" },
    { label: "Målgrupp", key: "target" }
  ];

  handleCancel(id) {
    this.context.router.history.push("/medier");
  }

  handleNav = e => {
    this.setState({ ...this.state, tab: e });
  };

  componentWillMount() {
    this.props.actions.fetchCategories();
    this.props.actions.fetchProviders();
    this.props.actions.fetchPersons();
    this.props.actions.fetchMediagroups();
    this.props.actions.fetchBrands();
    this.props.actions.fetchBrand(this.props.params.id);
  }
  renderPage() {
    if (!this.props.brand) return <p>Loading..</p>;

    return (
    <div>
      {this.state.tab === "summary" && (
        <PageSection nav="summary">
          <PageBlock right={true} label="Kanaler">
            {this.props.brand.categories && (
              <CategoryGrid
                brandid={this.props.params.id}
                brand={this.props.brand}
                categories={this.props.brand.categories}
              />
            )}
          </PageBlock>
        </PageSection>
      )}
      {this.state.tab === "statistics" && (
        <PageSection nav="statistics">
          {_.map(this.props.brand.categories, (c, key) => (
            <div key={key}>
              <BrandCategoryStats title={c.name} stats={c.stats} />
            </div>
          ))}
        </PageSection>
      )}
      {this.state.tab === "target" && (
        <PageSection nav="target">
          <PageBlock right={true} label="Målgrupp">
            <ChartTargetGender item={this.props.brand} />
          </PageBlock>

          {/* <PageBlock label="Beskrivning" className="textlimit">
           <Paragraphs text={this.props.brand.targetgroup || this.props.brand.description} />
           </PageBlock> */}
        </PageSection>
      )}
    </div>
    );
  }

  render() {
    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Beskrivning">
          <ReadMore height="22em">
            <Paragraphs boldfirst={true} text={this.props.brand.description} />
          </ReadMore>
        </PageBlock>

        <PageBlock label="Målgrupper">
          <AgeInfo item={this.props.brand} label="Ålder" />
          <GenderInfo item={this.props.brand} label="Könsfördelning" />
        </PageBlock>

        {this.props.brand.reach && 
          <PageBlock label="Räckvidd">
            <p><Number value={this.props.brand.reach} /> individer</p>
          </PageBlock>
        }

        {this.props.brand.persons && (
          <PageBlock label="Personer">
            <AvatarList persons={this.props.brand.persons} />
          </PageBlock>
        )}

      {this.props.brand.url && this.props.brand.url.indexOf('http') === 0 &&
        <PageBlock label="Övrigt">
          <p>Länk till webbsida: <br/><a href={this.props.brand.url} rel="nofollow">{this.props.brand.url}</a></p>
        </PageBlock>
        }
        {this.props.brand.url && this.props.brand.url.indexOf('http') !== 0 &&
        <PageBlock label="Övrigt">
          <p>Adress till webbsida: <br/>{this.props.brand.url}</p>
        </PageBlock>
        }

      </RightDrawer>,
      <header id="hero" key="brand_hero">
        <BrandHeader
          onNav={this.handleNav}
          tabs={this.tabs}
          brand={this.props.brand}
        >
          {this.props.brand.segments && (
            <SegmentList segments={this.props.brand.segments} />
          )}
        </BrandHeader>
      </header>,
      <Page key="brand_page" ready={!this.props.pending} className="brand">
        {this.renderPage()}
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  var brand = state.brands.details.data;

  if (!brand || !state.mediagroups.list.data || !state.categories.list.data) {
    return {};
  }

  var statscategories = [];
  var categories = state.categories.list.data;
  _.each(brand.categories, (v, k) => {
    statscategories.push({ ...categories[v.categoryid], ...v });
  });
  return {
    brand: brand,
    stats: statscategories.map(c => c.stats).filter(s => !!s),
    mediagroups: state.mediagroups.list.data
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...brands, ...categories, ...persons, ...mediagroups, ...providers },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(BrandPage);



// WEBPACK FOOTER //
// ./src/pages/brands/BrandPage.jsx